import { render, staticRenderFns } from "./HandleCustomerProblem.vue?vue&type=template&id=3d09f8c1&scoped=true&"
import script from "./HandleCustomerProblem.vue?vue&type=script&lang=js&"
export * from "./HandleCustomerProblem.vue?vue&type=script&lang=js&"
import style0 from "./HandleCustomerProblem.vue?vue&type=style&index=0&id=3d09f8c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09f8c1",
  null
  
)

export default component.exports